import { render } from "./ProjectNote.vue?vue&type=template&id=1c353014&scoped=true"
import script from "./ProjectNote.vue?vue&type=script&lang=js"
export * from "./ProjectNote.vue?vue&type=script&lang=js"

import "./ProjectNote.vue?vue&type=style&index=0&id=1c353014&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c353014"]])

export default __exports__